import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Button, useTheme } from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery'
import { decodeHtml } from '../../../utils/misc'

interface Props {
  text: string
  lines?: number
}

const ProductOverview: React.FC<Props> = ({ text, lines = 3 }) => {
  const [expanded, setExpanded] = React.useState(false)
  const theme = useTheme()
  const mdUp = useMediaQuery(theme.breakpoints.up('md'))

  return (
    <Box className='mt-10 mb-20'>
      {mdUp ? (
        <Typography
          variant='body1'
          sx={{
            display: '-webkit-box',
            WebkitLineClamp: expanded ? 'unset' : lines,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }}
        >
          <span className='text-lg text-gray leading-snug'>{decodeHtml(text)}</span>
        </Typography>
      ) : (
        <Typography
          variant='body1'
          sx={{
            display: '-webkit-box',
            WebkitLineClamp: expanded ? 'unset' : lines,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }}
        >
          <span className='text-base text-gray leading-snug'>{decodeHtml(text)}</span>
        </Typography>
      )}

      {text.length > 200 && (
        <Button
          variant='text'
          size='small'
          sx={{
            mt: 0.5,
            p: 0,
            minWidth: 'auto',
            textTransform: 'none',
          }}
          disableElevation
          disableRipple
          disableFocusRipple
          disableTouchRipple
          onClick={() => setExpanded(v => !v)}
        >
          <span className='text-gray'>{expanded ? 'Show less' : 'Show more'}</span>
        </Button>
      )}
    </Box>
  )
}

export default ProductOverview
